import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=10d0853e&scoped=true&"
import script from "./step1.vue?vue&type=script&lang=js&"
export * from "./step1.vue?vue&type=script&lang=js&"
import style0 from "./step1.vue?vue&type=style&index=0&id=10d0853e&prod&lang=scss&"
import style1 from "./step1.vue?vue&type=style&index=1&id=10d0853e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0853e",
  null
  
)

export default component.exports